<template>
  <div class="analytics account-analytics">
    <filter-bar :timeframe="timeframe" @change="setTimeframe" />

    <stats
      :data="basicMetrics"
      :props="basicMetricProps"
      :min-width="minWidth"
    />

    <treemap
      v-if="dimensions && treemapItems"
      :items="treemapItems"
      :width="dimensions.width"
      :height="800"
      :min-width="minWidth"
      :type="'user'"
    />

    <line-chart
      v-if="readership && timeframeLabels && dimensions"
      :items="readership"
      :timeframe-labels="timeframeLabels"
      :width="dimensions.width"
      :height="400"
      :min-width="minWidth"
      :timeframe="timeframe"
    />

    <ranking-list
      title="Top Articles"
      :items="
        (cogData ? cogData.topArticlesByTimeframe[timeframe] : []).map(
          (tr) => ({
            id: tr.articleId,
            name: tr.article ? tr.article.title : '-',
            value: tr.views,
            lastValue: 0,
            diffNum: false,
            diffStr: '',
            webDownloads: tr.downloads || 0,
            emailViews: 0,
            sendgridOpened: 0,
            valueRank: 1,
            lastValueRank: -1,
            change: 0,
            engagement: 4,
            position: 1,
            account: '',
            account_id: 0,
            channel: tr.article ? tr.article.channel : '-',
            channel_id: tr.article ? tr.article.channelId : '-',
            analyst: tr.article ? tr.article.primaryAnalyst || '-' : '-',
            analyst_id: tr.article ? tr.article.analystIds[0] : '-',
            companies: null,
            email: '',
          })
        )
      "
      :active-id="data.id"
      :settings="topListTypes['accountArticle']"
      :client-width="clientWidth"
    />
  </div>
</template>

<script>
import { constructReadership } from '@/analytics/data-analyser'

import AnalyticsMixin from '@/analytics/mixins/AnalyticsMixin'
import TimeframeMixin from '@/analytics/mixins/TimeframeMixin'

import FilterBar from '@/components/FilterBar'
import RankingList from '@/components/RankingList'
import Stats from '@/components/Stats'
import LineChart from '@/components/d3/LineChart'
import Treemap from '@/components/d3/Treemap'

export default {
  mixins: [AnalyticsMixin, TimeframeMixin],
  components: {
    FilterBar,
    RankingList,
    Stats,
    LineChart,
    Treemap,
  },
  props: {
    channelName: {
      type: String,
      default: 'Network',
    },
  },
  async mounted() {
    const response = await this.loadData(
      `accounts/${this.data.id}`,
      this.timeframe,
      this.$login.channelScopeId()
    )
  },
  data() {
    return {
      analyticsType: 'account',
      timeframeLabels: [],
      basicMetricProps: ['emailOpens', 'webViews', 'accountStat'],
      topListTypes: {
        // accountTopic: {
        //   title: 'Key Interests',
        //   path: false,
        //   colWidth: 6,
        //   activeEnabled: false,
        //   cols: null,
        //   type: 'infinity-rank',
        // },
        // networkAccount: {
        //   title: `${this.channelName} League Table`,
        //   path: 'accounts',
        //   colWidth: 6,
        //   activeEnabled: true,
        //   cols: null,
        // },
        accountArticle: {
          title: 'Top Articles',
          path: 'articles',
          colWidth: 12,
          activeEnabled: true,
          cols: ['name', 'channel', 'analyst', 'webDownloads', 'engagement'],
          type: 'infinity-rank',
        },
      },
      user: this.$login.getUser(),
    }
  },

  computed: {
    lineChartSources() {
      // return {}
      return { web: ['article_views'] }
    },
  },
  watch: {
    timeframe: function (timeframe, oldData) {
      // this.loadData(timeframe)
      if (this.cogData) {
        this.treemapItems = this.cogData.engagement[this.timeframe].users.map(
          (ae) => ({
            id: ae.id.toString(),
            name: ae.name,
            value: ae.value,
            lastValue: ae.lastValue,
            diffNum: ae.difference,
            diffStr: ae.differenceText,
            valueRank: ae.rank,
            lastValueRank: ae.prevRank,
            change: ae.rankChange,
            position: ae.rank,
          })
        )
        this.timeframeLabels = this.cogData.series[
          this.timeframe
        ].webViewsDaily.map((item) => item.date)
        this.basicMetrics = this.cogData.basicMetrics[this.timeframe].totals
        this.readership = {
          webViews: this.cogData.series[this.timeframe].webViewsDaily.map(
            (x) => x.value
          ),
        }
      }
    },

    cogData() {
      this.treemapItems = this.cogData.engagement[this.timeframe].users.map(
        (ae) => ({
          id: ae.user.id.toString(),
          name: ae.user.name,
          value: ae.value,
          lastValue: ae.lastValue,
          diffNum: ae.difference,
          diffStr: ae.differenceText,
          valueRank: ae.rank,
          lastValueRank: ae.prevRank,
          change: ae.rankChange,
          position: ae.rank,
        })
      )

      this.basicMetrics = this.cogData.basicMetrics[this.timeframe].totals
      this.readership = {
        webViews: this.cogData.series[this.timeframe].webViewsDaily.map(
          (x) => x.value
        ),
      }
      this.timeframeLabels = this.cogData.series[
        this.timeframe
      ].webViewsDaily.map((item) => item.date)
      const userStat = {
        gdpr: this.data.is_gdpr_compliant,
        reader: this.basicMetrics.current.webViews,
      }
      this.$set(this.basicMetrics.current, 'userStat', userStat)
    },
    basicMetrics(data) {
      if (data && this.cogData) {
        const accountStat = {
          mifid: this.data.is_mifid,
          account_type: this.data.account_type.name,
        }
        this.$set(this.basicMetrics.current, 'accountStat', accountStat)
      }
    },
  },
  methods: {
    async constructTreemap() {
      this.treemapItems = await this.constructTopList(
        this.analyticsType,
        'user',
        'custom_attributes.user_id',
        this.data.id,
        this.sources
      )
    },
  },
}
</script>
